<script>
import { get } from 'vuex-pathify'

export default {
	props: {
		receta: Object,
		removeLoading: Boolean,
	},
}
</script>

<template>
	<div class="pt-4 pa-sm-4 rounded-lg" style="background: rgba(0, 0, 0, 0.05)" :id="`receta-${receta.id}`">
		<div
			class="d-flex flex-column flex-sm-row align-center pb-sm-2"
			:style="$b({ m: {}, _: { borderBottom: '1px solid #aaa', gap: '16px' } })"
		>
			<v-icon>mdi-file-document</v-icon>
			<b>{{ receta.financiador.displayName }}</b>
			<span v-if="!$b.m">|</span>
			<b>Afiliado #{{ receta.nroAfiliado }}</b>
			<span v-if="!$b.m">|</span>
			<b>Receta #{{ receta.nroReceta }}</b>
			<v-spacer />
			<Button text small color="error" @click="$emit('remove')" :loading="removeLoading">
				<v-icon left small>mdi-close</v-icon> Quitar Receta
			</Button>
		</div>
		<!-- Lista de Drogas referenciasRx -->
		<div class="py-0 py-sm-2">
			<RecetaDigitalDrogaItem
				v-for="(referenciaRx, i) of receta.referenciasRx"
				:key="i"
				:receta="receta"
				:referencia-rx="referenciaRx"
			/>
		</div>
	</div>
</template>

